module.exports = __webpack_public_path__ + "static/media/journals-icon.66968c84.svg";